import { Skeleton, Stack } from '@mui/material'
import { FC } from 'react'
import { SkeletonText } from 'utoniq-ui'

enum Size {
  SMALL = 'small',
  DEFAULT = 'default',
}

enum Orientation {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}

export type StoreItemAreaSkeletonProps = {
  size?: `${Size}`
  orientation?: `${Orientation}`
  responsive?: boolean
}

export const StoreItemAreaSkeleton: FC<StoreItemAreaSkeletonProps> = ({
  size = Size.DEFAULT,
  orientation = Orientation.VERTICAL,
  responsive = false,
}) => {
  const width = responsive ? '100%' : size === Size.SMALL ? 60 : 104

  if (size === Size.SMALL) {
    return <Skeleton variant="rectangular" sx={{ width: width, height: 96 }} />
  }
  return (
    <Stack spacing={1}>
      <Skeleton variant="rectangular" sx={{ width: width, height: 166 }} />
      <SkeletonText variant="small" width="50%" />
      <SkeletonText variant="small" width="30%" />
      <SkeletonText variant="medium" width="50%" />
    </Stack>
  )
}
